import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  data: any;
  downloadUrl?: string; // New optional prop
}

const InfoModal: React.FC<InfoModalProps> = ({ isOpen, onClose, title, data, downloadUrl }) => {
  if (!isOpen) return null;

  const handleDownload = () => {
    if (downloadUrl) {
      window.open(downloadUrl, '_blank'); // Open in new tab to trigger download
    }
  };

  const renderContent = () => {
    if (!data) return <p>无可用数据。</p>;
    if (typeof data === 'string') return <ReactMarkdown remarkPlugins={[remarkGfm]}>{data}</ReactMarkdown>;
    if (Array.isArray(data)) {
      if (data.length === 0) return <p>未找到任何记录。</p>;
      const headers = Object.keys(data[0]);
      return (
        <table border={1} style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {headers.map(header => <th key={header}>{header}</th>)}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                {headers.map(header => <td key={header}>{JSON.stringify(row[header])}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
    return <pre>{JSON.stringify(data, null, 2)}</pre>;
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <h3>{title}</h3>
        <div style={styles.contentWrapper}>
          {renderContent()}
        </div>
        <div style={styles.buttonContainer}>
          {downloadUrl && (
            <button onClick={handleDownload} style={styles.downloadButton}>
              下载
            </button>
          )}
          <button onClick={onClose} style={styles.closeButton}>关闭</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    width: '80%',
    maxHeight: '80%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  closeButton: {
    marginLeft: 'auto',
    marginTop: '10px',
  },
  contentWrapper: {
    marginTop: '20px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '10px',
  },
  downloadButton: {
    marginRight: '10px',
  },
} as const;


export default InfoModal;
